import { CustomFieldsDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCalendarEventControllerModule } from './controllers/CalendarEventController';

export const ProgramsCalendarEventView = angular
  .module('acme.view.application.programs.calendar.event', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    ProgramsCalendarEventControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.calendar.event',
      url: '/event',
      views: {
        'subview-main': {
          controller: 'CalendarEventController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/calendar/event/event.tpl.html',
        },
      },
      data: {
        pageTitle: 'Calendar',
        permissions: ['EVENT_CALENDAR_VIEW'],
        roles: ['user', 'admin'],
      },
      resolve: {
        CustomFieldsData: CustomFieldsDataResolver(),
      },
    });
  }).name;
